export default __webpack_public_path__ + "static/media/cross.191c6a7f.svg";